import React, { useState } from "react";
import AvatarImg from "../../../assets/images/user.png"
import { CogIcon, ChevronRightIcon } from '@heroicons/react/outline'
import { LogoutIcon } from '@heroicons/react/solid'
import useHandleClickOutside from '../HandleClickOutside/HandleClickOutside';
import AuthService from "../../../services/AuthService";

const UserDropdown = () => {
    const [isOpen, setIsOpen] = useState(false)
    const handleToggleIsOpen = () => setIsOpen(isOpen => !isOpen);
    const logout = () => AuthService.logout();
    let domNode = useHandleClickOutside(() => {
        setIsOpen(false);
    })

    return (
        <div ref={domNode} className="relative z-10 ml-auto">
            <div className="flex items-center cursor-pointer" onClick={handleToggleIsOpen}>
                <CogIcon className="w-4 h-4 mr-1 text-gray-700" />
                <ChevronRightIcon className={`w-3.5 h-3.5 text-gray-700 transition-transform ${isOpen ? 'rotate-90' : ''}`} />
            </div>
            <div className={`absolute right-0 -bottom-4 translate-y-full rounded-lg overflow-hidden bg-white shadow-userDropdown origin-top-right transition-all  ${isOpen ? 'opacity-100 scale-1 pointer-events-auto' : 'opacity-0 scale-50 pointer-events-none'}`} >
                <div className="flex items-center blueGradient py-2 px-4">
                    <div className="h-9 w-9 rounded-full border border-2 border-white">
                        <img src={AvatarImg} alt="" />
                    </div>
                    <span className="ml-3 mr-10 text-xs font-semibold text-white">Admin</span>
                    <span title="Logout" className="cursor-pointer">
                        <LogoutIcon onClick={() => logout()} className="h-4 text-white" />
                    </span>
                </div>
                <div className="flex flex-col py-2">
                    <a href="/" className="py-2 px-4 text-xs text-gray-600 hover:text-bluePrimary transition" onClick={() => logout()}>Odjavi se</a>
                </div>
            </div>
        </div>
    )
};

export default UserDropdown;
